module.exports = __webpack_public_path__ + "media/old_images/default-image-list-object-536d856f.png";